
import React from 'react';
import { Button } from '@/components/ui/button';

interface AgeVerificationModalProps {
  showModal: boolean;
  onVerification: (isOver18: boolean) => void;
}

const AgeVerificationModal = ({ showModal, onVerification }: AgeVerificationModalProps) => {
  if (!showModal) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white p-8 rounded-lg max-w-md mx-auto text-center">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Age Verification</h2>
        <p className="text-gray-700 mb-6">Are you 18 years or older?</p>
        <div className="space-x-4">
          <Button 
            onClick={() => onVerification(true)}
            className="bg-yellow-600 hover:bg-yellow-700"
          >
            I'm 18+
          </Button>
          <Button 
            onClick={() => onVerification(false)}
            variant="outline"
          >
            I'm under 18
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AgeVerificationModal;
